import { createFileRoute } from "@tanstack/react-router"
import DesignSystemLinkButton from "~/pages/design-system/components/LinkButton"

export const Route = createFileRoute("/_auth/internal/design-system/components/link-button")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemLinkButton />
}
